import * as Types from './types';
import { actionTypes } from './constants';

export * from '@core/js/components/main/GamesGrid/store/actions';

export const setActiveCategory = (activeCategory: string): Types.IActiveCategoryUpdateAction => ({
    type: actionTypes.GAMES_GRID_ACTIVE_CATEGORY_UPDATE,
    payload: activeCategory
});

export const setExpandedCategory = (expandedCategory: string): Types.IExpandedCategoryUpdateAction => ({
    type: actionTypes.GAMES_GRID_EXPANDED_CATEGORY_UPDATE,
    payload: expandedCategory
});
